<button [tabindex]="tabindex()" [disabled]="disabled()" class="button__container" matRipple [type]="action()">
  <div class="button__label">
    <ng-content></ng-content>
  </div>
</button>
